export const games = {
  titleBreakingLeague: "ESTÁN ROMPIENDO LA LIGA",
  titleBreakingLeagueMobile: "💥 ESTÁN ROMPIENDO LA LIGA",
  gamesSubTitle: "No quieren dejar pa` nadie.",
  recentTitle: "LOS MÁS RECIENTES",
  recentTitleMobile: "📢 LOS MÁS RECIENTES",
  recentSubTitle: "Prueba suerte con nuestras novedades",
  newLabel: "NUEVO",
  top10GamesTitle: "LOS",
  top10GamesTitle2: "MÁS JUGADOS",
  top10GamesSubTitleDesktop: "Vea los juegos más jugados de Venezuela",
  top10GamesSubTitleMobile: "LOS <highlight>10</highlight> MÁS JUGADOS",
  randomTitle: "¿No te decides?",
  randomTitleMobile: "🍀 Que la suerte decida!",
  randomDescription:
    "Dale play y deja que la suerte elija tu próximo juego ganador. 🎯 Elige una categoría, presiona el botón... ¡y que empiece la suerte!",
  randomDescriptionMobile: "Dale play y deja que la suerte elija tu próximo juego ganador.",
  selectCategory: "Elige una categoría",
  randomPlayButton: "¡A jugar!",
  randomQuestion: "¿Cuál será el próximo juego en darte suerte? 🍀",
  randomButton: "Ir al juego 🚀",
  topPayingGamesTitle: "LOS QUE MÁS PAGAN",
  topPayingGamesSubTitle: "Andan soltando money",
  recentlyPlayedTitle: "SIGUE JUGANDO",
  recentlyPlayedSubTitle: "Retoma donde lo dejaste",
  lotteryGamesTitle: "JUEGOS DE LOTERÍA",
  lotteryGamesSubTitle: "Prueba tu suerte con nuestras loterías",
  allGamesTitle: "TODOS LOS JUEGOS",
  dontMiss: "NO TE LO PIERDAS",
  dontMissTournaments: "Torneos, tiradas gratis, promos y más.",
  tournamentRules: "Reglamento",
  // Multi-Game Floating Button translations
  multiGameFloatingButton: "Juegos Rápidos",
  quickGamesTitle: "Juegos Rápidos",
  quickGamesDescription: "¡Sigue jugando mientras esperas tu juego principal!",
  hideQuickGames: "Ocultar",
  minimizeQuickGames: "Minimizar",
  playNow: "Jugar Ahora",
  noQuickGamesAvailable: "No hay juegos disponibles en este momento",
  unknownGame: "Juego Desconocido",
  unknownProvider: "Desconocido",
  loadingGames: "Cargando juegos...",
};
